export const INITIALIZE_VIEW = "INITIALIZE_VIEW"
export const FETCH_CALENDAR_DATA_START = "FETCH_CALENDAR_DATA_START"
export const FETCH_CALENDAR_DATA_SUCCESS = "FETCH_CALENDAR_DATA_SUCCESS"
export const FETCH_CALENDAR_DATA_FAILURE = "FETCH_CALENDAR_DATA_FAILURE"

const initialState = {
  products: [],
  onSlotClickActionType: "new_order",
  slots: {
    model: [],
    maxVisibleDate: null,
    fetchDone: false,
    fetchLoading: false,
    fetchFailed: false,
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_VIEW:
      return {
        ...state,
        products: action.products,
        onSlotClickActionType: action.onSlotClickActionType,
      }

    case FETCH_CALENDAR_DATA_START:
      return {
        ...state,
        slots: {
          ...state.slots,
          fetchLoading: true,
        }
      }

    case FETCH_CALENDAR_DATA_SUCCESS:
      return {
        ...state,
        slots: {
          ...state.slots,
          model: _.uniqBy( state.slots.model.concat(action.slots) , sl => sl.id ),
          maxVisibleDate: action.maxVisibleDate,
          fetchDone: true,
          fetchFailed: false,
          fetchLoading: false,
        }
      }

    case FETCH_CALENDAR_DATA_FAILURE:
      return {
        ...state,
        slots: {
          ...state.slots,
          fetchFailed: true,
          fetchLoading: false,
        }
      }

    default:
      return state
  }
}

export function initializeView({ products, onSlotClickActionType }) {
  return dispatch => {
    dispatch({ type: INITIALIZE_VIEW, products, onSlotClickActionType })
  }
}

export function fetchCalendarData({ maxVisibleDate }) {
  return (dispatch, getState) => {
    const { products, slots: { fetchLoading, maxVisibleDate: currentMaxVisibleDate } } = getState()

    if (fetchLoading) { return }
    if (currentMaxVisibleDate && currentMaxVisibleDate >= maxVisibleDate) { return }

    dispatch({ type: FETCH_CALENDAR_DATA_START, maxVisibleDate })
    return st.resources.widgets.getProductsCalendarData({
      product_ids: products.map(p => p.id).join(','),
      starts_at_gte: currentMaxVisibleDate ? moment(currentMaxVisibleDate).format(moment.RUBY_DATE_FORMAT) : undefined,
      starts_at_lte: moment(maxVisibleDate).format(moment.RUBY_DATE_FORMAT),
    })
      .then(
        data => {
          dispatch({ type: FETCH_CALENDAR_DATA_SUCCESS, slots: data.slots, maxVisibleDate })
        },
        error => {
          dispatch({ type: FETCH_CALENDAR_DATA_FAILURE, error })
        },
      )
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/ProductsCalendarWidget/duck.js